module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/return-1f8a339d99f8dc6cbfc7d481310d9790.svg&quot;;"